<script setup lang="ts">
import type { UmbracoFormField } from 'types/blocks';

const props = defineProps<{
  field: UmbracoFormField;
}>();

const { getLabel, showLabel } = useForm();
const formStore = useFormStore();

const isChecked = ref(false);

watch(isChecked, (newValue) => {
  formStore.setFieldValue(props.field.alias, newValue);
});
</script>

<template>
  <div class="flex items-center gap-3">
    <CheckboxRoot
      :id="field.id"
      v-model="isChecked"
      :required="field.required"
      :disabled="formStore.isDisabled"
      :name="field.alias"
      value="true"
    >
      <CheckboxIndicator>
        <BaseIcon
          name="check"
          size="18"
          stroke-color="var(--color-white-pure)"
        />
      </CheckboxIndicator>
    </CheckboxRoot>

    <Label
      v-if="showLabel(field)"
      class="form__label flex-shrink-0 flex-grow basis-0"
      :for="field.id"
    >
      {{ getLabel(field) }}
    </Label>
  </div>
</template>
